import React, { useContext, useRef, useState } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native';
import { SHARED_SVGS } from '../assets';
import DateRangeCalendar from '../data-range-calendar/data-range-calendar';
import { PopupActions } from 'reactjs-popup/dist/types';
import Popup from 'reactjs-popup';

interface Props {
  iconViewColor: string;
  calendar?: {
    open: boolean;
    setOpen: (state: boolean) => void;
    dateSelectionRange: { startDate: Date; endDate: Date };
    setDateSelectionRange: (val: { startDate: Date; endDate: Date }) => void;
  };
  iconSize?: number;
}

export const CalendarComponent: React.FC<Props> = ({
  iconViewColor,
  calendar,
  iconSize = 30,
}) => {
  const [highlight, setHighlight] = useState(false);
  const { theme } = useContext(ThemeContext);
  const popupRef = useRef<PopupActions>(null);
  return (
    <TouchableOpacity activeOpacity={1}>
      <Popup
        ref={popupRef}
        trigger={
          <View
            style={[
              styles.icon,
              styles.margin,
              {
                backgroundColor: iconViewColor,
                borderColor: iconViewColor,
                paddingHorizontal: 5,
              },
              highlight
                ? theme.filterButton.selected
                : theme.filterButton.unselected,
            ]}
          >
            <Image
              source={{ uri: SHARED_SVGS.Calender }}
              style={{ height: iconSize, width: iconSize }}
            />
          </View>
        }
        on="click"
        arrow={false}
        onOpen={() => {
          setHighlight(true);
          calendar?.setOpen(true);
        }}
        open={calendar?.open}
        onClose={() => {
          setHighlight(false);
          calendar?.setOpen(false);
        }}
      >
        {calendar ? (
          <DateRangeCalendar
            closeDialog={() => {
              setHighlight(false);
              calendar.setOpen(false);
              popupRef.current?.close();
            }}
            startDate={calendar.dateSelectionRange?.startDate}
            endDate={calendar.dateSelectionRange?.endDate}
            setDateSelectionRange={calendar.setDateSelectionRange}
          />
        ) : undefined}
      </Popup>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  icon: {
    borderRadius: 6,
    // padding: 4,
    borderWidth: 1,
  },
  margin: {
    // marginHorizontal: 6,
  },
});
